import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ReactTable from 'react-table';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, UncontrolledTooltip } from "reactstrap";
import update from 'immutability-helper';
import qs from 'qs';

const ProductCileList = (props) => {
    const config = new Configurations();
    const [isLoadingProdutos, setIsLoadingProdutos] = useState(true);
    const [modalStatusProduto, setModalStatusProduto] = useState(false);
    const [metodoStatusProduto, setMetodoStatusProduto] = useState("ativar");
    const [listaProdutos, setListaProdutos] = useState([]);
    const [idProdStatusAlteracao, setIdProdStatusAlteracao] = useState(null);
    const [nomeProdStatusAlteracao, setNomeProdStatusAlteracao] = useState("");
    const [isLoadingStatusProduto, setIsLoadingStatusProduto] = useState(false);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [busca, setBusca] = useState('');
    const [buscaInput, setBuscaInput] = useState('');

    const paramsUrl = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    const pagina = parseInt(paramsUrl.pagina, 10) || 1;
    const limite = parseInt(paramsUrl.limite, 10) || 10;

    const columns = [
        {
            Header: 'id',
            accessor: 'idProduto',
            className: 'text-center pointer',
            width: 50
        },
        {
            Header: 'Nome',
            accessor: 'nome',
            className: 'text-center pointer',
            width: 350
        },
        {
            Header: 'Tipo',
            accessor: 'tipoProduto',
            className: 'text-center pointer',
            width: 140
        },
        {
            Header: 'SKU',
            accessor: 'sku',
            className: 'text-center pointer',
            width: 100
        },
        {
            Header: 'Dt. criação',
            className: 'text-center pointer',
            accessor: 'dtCriacao',
            width: 130,
            Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>-</span>)
        },
        {
            Header: 'Dt. modificação',
            className: 'text-center pointer',
            accessor: 'dtModificacao',
            width: 130,
            Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>-</span>)
        },
        {
            Header: 'Usuário',
            accessor: 'usuario',
            className: 'text-center pointer',
            width: 120
        },
        {
            Header: 'Status',
            className: 'text-center pointer',
            accessor: 'ativo',
            Cell: row => (<h6 className="m-0"><span className={`badge badge-${row.value ? 'success' : 'secondary badge-opacity'}`}>{row.value ? 'Ativo' : 'Inativo'}</span></h6>),
            width: 120,
        },
        {
            Header: '',
            className: 'text-center pointer',
            Cell: row => {
                const _ativo = row.original.ativo,
                    _functionBtn = _ativo ? "desativar" : "ativar",
                    _classIcon = _ativo ? `far fa-eye-slash` : `far fa-eye`,
                    _textTooltip = _ativo ? "desativar produto" : "ativar produto";
                return (
                    <div className="row no-gutters">
                        <div className="col-12 icones" id={`Tooltip-${row.original.idProduto}`}>
                            {row.original.loading ? (
                                <div className="spinner-border spinner-border-sm text-primary" role="status" />
                            ) : (
                                <button onClick={() => confirmaStatusAlteracao(row.original.idProduto, row.original.nome, _functionBtn)}>
                                    <i className={`${_classIcon}`}></i>
                                </button>
                            )}
                            <UncontrolledTooltip placement="top" target={`Tooltip-${row.original.idProduto}`}>
                                {_textTooltip}
                            </UncontrolledTooltip>
                        </div>
                    </div>
                )
            }
        },
    ];


    const carregaProdutos = () => {
        setIsLoadingProdutos(true);
        let url = `/v2/produtos?pagina=${pagina}&limite=${limite}`;
        if (busca) url += `&busca=${encodeURIComponent(busca)}`;
        axios.get(config.apiBasePath + url)
            .then(response => {
                setListaProdutos(response.data.produtos);
                setTotalPaginas(response.data.paginacao.totalPaginas);
            })
            .catch(err => console.log(err))
            .finally(() => {
                setIsLoadingProdutos(false);
            });
    }

    const atualizaUrl = (_pagina, _limite) => {
        props.history.push({ pathname: props.location.pathname, search: `?pagina=${_pagina}&limite=${_limite}` });
    };

    useEffect(() => {
        if (!paramsUrl.pagina || !paramsUrl.limite) {
            props.history.replace({ pathname: props.location.pathname, search: `?pagina=${pagina}&limite=${limite}` });
            return;
        }
        carregaProdutos();
    }, [props.location.search, busca]);

    const handleBuscar = (e) => {
        e.preventDefault();
        atualizaUrl(1, limite);
        setBusca(buscaInput.trim());
    };

    const handleLimparBusca = () => {
        setBuscaInput('');
        setBusca('');
        atualizaUrl(1, limite);
    };

    const mudaStatusProduto = () => {
        setIsLoadingStatusProduto(true);
        setModalStatusProduto(false);
        const _index = listaProdutos.findIndex(item => parseInt(item.idProduto, 10) === parseInt(idProdStatusAlteracao, 10));
        setListaProdutos(update(listaProdutos, { [_index]: { loading: { $set: true } } }));
        axios.put(config.apiBasePath + `/v2/produtos/${idProdStatusAlteracao}/${metodoStatusProduto}`)
            .then(() => {
                carregaProdutos();
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                setIsLoadingStatusProduto(false);
            });
    }

    const confirmaStatusAlteracao = (_idProd, _nomeProd, _metodo) => {
        setModalStatusProduto(true);
        setIdProdStatusAlteracao(_idProd);
        setNomeProdStatusAlteracao(_nomeProd);
        setMetodoStatusProduto(_metodo);
    }

    const selecionaProduto = (_idProd) => {
        props.history.push({ pathname: `/cile/produtos/detalhes/${_idProd}` });
    }

    const onPageChange = pageIndex => {
        atualizaUrl(pageIndex + 1, limite);
    };

    const onPageSizeChange = (pageSize, pageIndex) => {
        atualizaUrl(pageIndex + 1, pageSize);
    };

    return (
        <div className="row edition-list">
            <div className="col-12">
                <div className="row no-gutters align-items-center">
                    <div className="col-12 col-lg-8 text-center text-lg-left">
                        <h2 className="title-1">CILE - Lista de Produtos</h2>
                    </div>
                    <div className="col-12 col-lg-4 text-center text-lg-right">
                        <div className="row no-gutters">
                            <div className="col py-2 py-lg-0">
                                <button className="btn btn-outline-info mx-2" type="button" name="novoProduto" onClick={() => props.history.push({ pathname: '/cile/produtos/detalhes/novo-produto' })}>
                                    Cadastrar novo produto
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="card mb-3 pb-2">
                    <div className="card-body py-2">
                        <form className="row align-items-end" onSubmit={handleBuscar} noValidate>
                            <div className="col-12 col-lg-8">
                                <div className="form-group mb-lg-0">
                                    <label htmlFor="txtBuscaProduto">Buscar por nome ou SKU</label>
                                    <input
                                        type="text"
                                        id="txtBuscaProduto"
                                        className="form-control"
                                        placeholder="Digite o nome ou o SKU do produto"
                                        value={buscaInput}
                                        onChange={e => setBuscaInput(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 text-lg-right py-2 py-lg-0">
                                <button className="btn btn-primary mr-2" type="submit">Buscar</button>
                                {busca && (
                                    <button className="btn btn-outline-secondary" type="button" onClick={handleLimparBusca}>Limpar</button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={`col-12`}>
                {isLoadingProdutos ? (
                    <div className="row no-gutters">
                        <div className="col-12 text-center py-5">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    </div>
                ) : (
                    <div className="row no-gutters">
                        <div className={`col-12`}>
                            <div className="row no-gutters">
                                <div className={`col-12 text-center text-lg-left`}>
                                    <p className="py-2 m-0">Clique no produto para obter mais informações.</p>
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <ReactTable
                                                data={listaProdutos}
                                                columns={columns}
                                                manual 
                                                pages={totalPaginas}
                                                page={pagina - 1}
                                                pageSize={limite}
                                                onPageChange={onPageChange}
                                                onPageSizeChange={onPageSizeChange}
                                                defaultPageSize={10}
                                                className="-striped -highlight"
                                                headerClassName="ebs-table-header"
                                                previousText='Anterior'
                                                nextText='Próximo'
                                                loadingText='Carregando...'
                                                noDataText='Nenhum produto encontrado.'
                                                pageText='Página'
                                                ofText='de'
                                                rowsText='linhas'
                                                loading={isLoadingProdutos}
                                                getTdProps={(state, rowInfo, column, instance) => {
                                                    return {
                                                        onClick: (e, handleOriginal) => {
                                                            if (rowInfo) {
                                                                if (column.Header === "") handleOriginal && handleOriginal();
                                                                else selecionaProduto(rowInfo.original.idProduto)
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Modal isOpen={modalStatusProduto} toggle={() => setModalStatusProduto(!modalStatusProduto)}>
                <ModalHeader toggle={() => setModalStatusProduto(!modalStatusProduto)}>
                    {metodoStatusProduto === 'ativar' ? `Ativar produto` : `Desativar produto`}
                </ModalHeader>
                <ModalBody>
                    {metodoStatusProduto === 'ativar' ? (
                        <p className="m-0">Deseja confirmar a ativação do produto <strong>{nomeProdStatusAlteracao}?</strong></p>
                    ) : (
                        <p className="m-0">Deseja desativar o produto <strong>{nomeProdStatusAlteracao}</strong>?</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    {isLoadingStatusProduto ? (
                        <div className="spinner-border text-primary" role="status" />
                    ) : (
                        <Button disabled={isLoadingStatusProduto} color={`${metodoStatusProduto === 'ativar' ? `success` : `danger`}`} onClick={mudaStatusProduto}>confirmar</Button>
                    )}
                    {' '}<Button color="secondary" onClick={() => setModalStatusProduto(!modalStatusProduto)}>voltar</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ProductCileList;